import React, { useCallback, useRef } from 'react';
import debounce from 'lodash/debounce';
import { Link as ReactRouterLink } from 'react-router-dom';
import { MODEL_PRELOAD_DEBOUNCE, PRELOAD_AEM_MODEL_EVENT } from './constants';
import { clearUrlPath } from './utils';
function preload(to) {
    try {
        const target = typeof to === 'string' ? to : to.pathname;
        if (typeof target !== 'string') {
            return;
        }
        window.document.body.dispatchEvent(new CustomEvent(PRELOAD_AEM_MODEL_EVENT, {
            detail: clearUrlPath(target),
        }));
    }
    catch (e) {
        console.error(e);
        // FINE;
    }
}
export const Link = (...args) => {
    const debouncedPreload = useRef(debounce(preload, MODEL_PRELOAD_DEBOUNCE)).current;
    const handleMouseEnter = useCallback((e) => {
        debouncedPreload(args[0].to);
        args[0].onMouseEnter?.(e);
    }, [debouncedPreload, args]);
    const handleMouseLeave = useCallback((e) => {
        // Cancel the debounced preload if mouse leaves
        debouncedPreload.cancel();
        args[0].onMouseLeave?.(e);
    }, [args, debouncedPreload]);
    return (React.createElement(ReactRouterLink, { ...args[0], onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }));
};
